import React from 'react';
import PropTypes from 'prop-types';
import TableResourceItem from './TableResourceItem';

const TableResourceItems = ({ tableItems, contractPartieId, handleEditFormOpen, handleAnswerFormLoad, editEnabled  }) => {
    // Verifica si tableItems es un array
  if (!Array.isArray(tableItems)) {
    console.error('tableItems debe ser un array');
    return null; // O cualquier otro manejo de error que desees
  }
  const allTableItems = tableItems.map(tableItem => (
    <TableResourceItem key={tableItem.id} tableItem={tableItem} contractPartieId={contractPartieId} editEnabled={editEnabled} />
  ));

  return <tbody>{allTableItems}</tbody>;
};

TableResourceItems.propTypes = {
  tableItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleEditFormOpen: PropTypes.func,
};

TableResourceItems.defaultProps = {
  tableItems: [
    {
      id: 1,
      code: 'XXXXXX',
      class: 'XXXXXX',
      type: 'XXXXXX',
      name: 'XXXXXX',
      prevExpense: 'XXXXXX',
      totalAmount: 'XXXXXX',
      l_polynomy: [{
        id: 1,
        index: 30.0,
        currency: "IPC",
        year: 2023,
        percent: 100
      },{
        id: 2,
        index: 70.0,
        currency: "USD",
        year: null,
        percent: null,
      }]
    },
  ],
};

export default TableResourceItems;
